"use client";

import { createContext, ReactNode } from "react";

import {
  useSignInModal,
  type AuthModalMode,
} from "@/components/modals/sign-in-modal";
import { useReviewModal } from "@/components/modals/review-modal";

export const ModalContext = createContext<{
  setShowSignInModal: (open: boolean, mode?: AuthModalMode) => void;
  setShowReviewModal: (open: boolean, defaultProduct?: string) => void;
}>({
  setShowSignInModal: () => {},
  setShowReviewModal: () => {},
});

export default function ModalProvider({ children }: { children: ReactNode }) {
  const { SignInModal, setShowSignInModal } = useSignInModal();
  const { ReviewModal, setShowReviewModal } = useReviewModal();

  return (
    <ModalContext.Provider
      value={{
        setShowSignInModal,
        setShowReviewModal,
      }}
    >
      <SignInModal />
      <ReviewModal />
      {children}
    </ModalContext.Provider>
  );
}
